<template>
  <div>
    <!-- <form name="ivipayMobile" method="post" action="/paymentresponse/mobile/ivi_deposit/merchant102">
      <input name="billNo" type="hidden" value="B04240111102214472SLH4">
    </form> -->

    <div class="pWrapper">
      <!-- 金额时间信息  start -->
      <section>
        <div class="payCount">
          <span>实应付款人民币金额</span>
          <p class="fr primary"><span id="timing">{{ timerCountInS == 0 ? '请重新提交订单！' : `进行中：${timerCountInMMSS}` }}</span></p>
        </div>
        <div class="payMoney">
          ￥{{ Utils.roundUp(Utils.accMul(amount, rate), 0).toFixed(2) }}
          <button ref="copyAmtOneBtn" class="copyBtn" :data-clipboard-text="Utils.roundUp(Utils.accMul(amount, rate), 0).toFixed(2)">复制</button>
        </div>
        <p style=" color: #333;" class="payMsg"> <font size="2px" /></p>
        <p><font size="2px">以下信息是确保您充值到账的重要信息:</font></p>
        <p><font size="2px">(1)请您将收款信息复制，贴上到<font color="red">网银/手机银行</font>银行的转账栏位进行付款</font></p>
        <p><font size="2px">(2)<font color="red">每次充值收款账号不同，务必进入此画面确认收款账号</font>，转错账号无法及时到账</font></p>
        <p><font size="2px">(3)<font color="red">转账金额必须一致</font>，否则充值无法及时到账</font></p><p />
        <p><font size="2px">(4)<font color="red">请付款成功后保留银行流水单或存款回执单以便上传快速上分</font></font></p><p />
      </section>
      <!-- 详细信息  end -->
      <!-- 转账信息  start -->
      <section>
        <div class="payTitle">转账信息</div>
        <table class="payTable">
          <tbody><tr>
                   <td>收款户名</td>
                   <td>{{ name }}</td>
                   <td><button ref="copyNameBtn" class="copyBtn" :data-clipboard-text="name">复制</button></td>
                 </tr>
            <tr>
              <td>收款银行</td>
              <td>{{ bank }}</td>
              <td><button ref="copyBankBtn" class="copyBtn" :data-clipboard-text="bank">复制</button></td>
            </tr>
            <tr>
              <td>收款卡号</td>
              <td>{{ number }}</td>
              <td><button ref="copyNumberBtn" class="copyBtn" :data-clipboard-text="number">复制</button></td>
            </tr>

            <tr>
              <td><b><font color="red">汇款金额</font></b></td>
              <td><b><font color="red">{{ Utils.roundUp(Utils.accMul(amount, rate), 0).toFixed(2) }}</font></b></td>
              <td><button ref="copyAmtTwoBtn" class="copyBtn" :data-clipboard-text="Utils.roundUp(Utils.accMul(amount, rate), 0).toFixed(2)">复制</button></td>
            </tr>

          </tbody></table>
        <p class="payInfo">转账时请务必按照以上转账信息，如不相同，资金将不能及时到账。</p>
      </section>
      <!-- 转账信息  end -->
      <!-- 确认按钮  start -->
      <div class="payBtnBox">
        <a id="payBtn" href="javascript:;" class="payBtn" @click="submit">我已付款</a>
      </div>
      <!-- 确认按钮  end -->

      <!-- 注意事项  start -->
      <dl class="becareful">
        <dt>注意事项</dt>
        <dd>1、请按照页面显示的付款金额，收款信息进行转账，如信息不匹配，资金将无法及时到账。</dd>
        <dd>2、订单的有效时间为15分钟，如您已转账但订单已失效，或超过15分钟未到账，请您联系客服处理</dd>
        <dd>3、若存款时有赠金活动，请在存款成功后联系客服领取赠金和红包</dd>
      </dl>
      <!-- 注意事项  end -->
      <!-- 付款确认 -->
      <div v-if="showConfirmSubmit" id="paySure" class="m-pop-bg">
        <div class="m-pop">
          <div class="content">为保证充值顺利到账，请确认是否已至网银/手机银行完成转账付款？</div>
          <div class="btnBox">
            <div class="flex-col">
              <a href="javascript:;" class="m-btn cancelBtn" @click="closeConfirmSubmit">否</a>
            </div>
            <div class="flex-col">
              <a href="javascript:;" class="m-btn sureBtn" @click="onConfirmSubmit">是</a>
            </div>
          </div>
        </div>
      </div>
    </div>


    <Transition name="toast">
      <div v-if="copyResultMsg !== ''" class="toastPop">{{ copyResultMsg }}</div>
    </Transition>


    <AlertPop
      :model="alertPop.show"
      :content="alertPop.content"
      :auto-hide-duration="alertPop.autoHideDuration"
      @alertOnClose="alertOnClose"
    />
    <!-- 指引弹窗 end -->
    <!-- <input id="timer" type="hidden">
    <script src="/resource/js/fastclick.1.0.6.min.js" />
    <script src="/resource/js/jquery.3.3.0.min.js" />
    <script src="/resource/js/clipboard.min.js" />
    <script src="/resource/js/guide.js" /> -->
  </div>
  </div></template>

<script>
require('@/assets/css/iviPayMobile.css')
import Clipboard from 'clipboard'
import AlertPop from '@/view/module/AlertPop.vue'
import { mapState } from 'vuex'
import utils from '@/utils/tradeDataUtil'

export default {
  name: 'IviPayMobile',
  components: { AlertPop },
  data() {
    return {
      name: '杨锐垤',
      bank: '梅州客商银行',
      number: '6236430860000007071',
      amount: this.$route.query.amount || 0,
      rate: this.$route.query.rate || 0,
      timerCountInS: 10,
      alertPop: {
        show: false
      },
      showConfirmSubmit: false,
      Utils: utils,
      copyResultMsg: '',
      copyResultToastTimeoutInSecs: 0.5,
      secsInMs: 1000,
      toastTimeoutId: -1

    }
  },
  computed: {
    ...mapState(['accountInfo']),
    timerCountInMMSS: {
      get() {
        var secNum = parseInt(String(this.timerCountInS), 10) // don't forget the second param
        var hours = Math.floor(secNum / 3600)
        var minutes = Math.floor((secNum - (hours * 3600)) / 60)
        var seconds = secNum - (hours * 3600) - (minutes * 60)

        // if (hours   < 10) {hours = `0${hours}`;}
        if (minutes < 10) { minutes = `0${minutes}` }
        if (seconds < 10) { seconds = `0${seconds}` }
        return `${minutes}:${seconds}`
      }
    }
  },
  watch: {
    timerCountInS: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCountInS--
          }, 1000)
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.initClipboard()
  },
  methods: {
    initClipboard() {
      const copyBtns = [this.$refs.copyAmtOneBtn, this.$refs.copyNameBtn, this.$refs.copyBankBtn, this.$refs.copyNumberBtn, this.$refs.copyAmtTwoBtn]
      const _this = this
      for (let i = 0; i < copyBtns.length; i++) {
        const c = new Clipboard(copyBtns[i])
        c.on('success', () => {
          // _this.alertPop = {
          //   show: true,
          //   content: '复制成功',
          //   autoHideDuration: 500
          // }
          _this.showToastWithMsg('复制成功')
        })
        c.on('error', () => {
          // _this.alertPop = {
          //   show: true,
          //   content: '请手动选择复制',
          //   autoHideDuration: 500
          // }
          _this.showToastWithMsg('复制失败，请手动选择复制')
        })
      }
    },
    alertOnClose() {
      this.alertPop = {
        show: false
      }
    },
    submit() {
      this.showConfirmSubmit = true
    },
    closeConfirmSubmit() {
      this.showConfirmSubmit = false
    },
    onConfirmSubmit() {
      this.showConfirmSubmit = false
      this.$router.push({ path: '/home/uploadDocuments', query: { from: 'IviPayMobile' } })
    },
    showToastWithMsg(msg) {
      const _this = this
      this.copyResultMsg = msg
      this.toastTimeoutId = setTimeout(() => {
        _this.copyResultMsg = ''
      }, _this.copyResultToastTimeoutInSecs * _this.secsInMs)
    },

  }
}
</script>
